export default __webpack_public_path__ + "static/media/tanveer.1d145dcd.png";